/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { Dimension, VisTextStyle } from '../UNSAFE_visTypes/common';

const isOverlap = (L1: number, R1: number, L2: number, R2: number) => L1 <= R2 && L2 <= R1;

/**
 * Checks if the two dimensions are overlapping horizontally.
 * @param dimsA
 * @param dimsB
 * @returns
 */
export function isWidthOverlap(dimsA: Dimension, dimsB: Dimension) {
  return isOverlap(dimsA.x, dimsA.x + dimsA.width, dimsB.x, dimsB.x + dimsB.width);
}

/**
 * Checks if the two dimensions are overlapping vertically.
 * @param dimsA
 * @param dimsB
 * @returns
 */
export function isHeightOverlap(dimsA: Dimension, dimsB: Dimension) {
  return isOverlap(dimsA.y, dimsA.y + dimsA.height, dimsB.y, dimsB.y + dimsB.height);
}

/**
 * Returns the updated title style.
 * @returns
 */
export function updateVisTextStyleProperties(style?: VisTextStyle) {
  if (style) {
    const { color, ...rest } = style;
    return { ...rest, stroke: color };
  }
  return style;
}
